import { useSelector } from 'react-redux';
import { authSelector } from '../../store';
import { hasTenantScopedPermission } from './permissionChecks';

export type HasPermissionFn = (requiredPermissions?: string[]) => boolean;

interface UsePermissionInterface {
  hasPermission: HasPermissionFn;
  hasNavAccess: (requiredPermissions?: string[], requiredRoles?: readonly string[], requiresSystemAdmin?: boolean) => boolean;
}

export const usePermission = (): UsePermissionInterface => {
  const {
    data: { privileges, roleValue, isSuper, isTenantSuperAdmin },
  } = useSelector(authSelector);

  const hasPermission: HasPermissionFn = (requiredPermissions) => {
    if (requiredPermissions) {
      for (const requiredPermission of requiredPermissions) {
        if (hasTenantScopedPermission(isTenantSuperAdmin, privileges, requiredPermission)) {
          return true;
        }
      }
      return false;
    }
    return true;
  };

  const hasNavAccess = (requiredPermissions?: string[], requiredRoles?: readonly string[], requiresSystemAdmin?: boolean) => {
    if (requiresSystemAdmin) {
      return isSuper === true;
    }

    if (requiredRoles?.includes(roleValue)) {
      return true;
    }

    return hasPermission(requiredPermissions);
  };

  return {
    hasPermission,
    hasNavAccess,
  };
};
